import { snackbarAdd } from "actions/snackbars";
import { loadWorkingOrder } from "actions/working-order-state";
import { WORKING_ORDER } from "constants/action-types";
import { progressEpic } from "epics/base-epic";
import { format } from "lib/globalize-util";
import { stringify } from "querystring";
import siteConfig from "site-config";

export const fetchWorkingOrder = progressEpic(
    WORKING_ORDER.ORDER.FETCH,
    ({ payload }: { payload: Record<string, any> }) => {
        const query = stringify(payload);
        return { url: `${siteConfig.api}/working` + (query ? "?" + query : ""), method: "GET" };
    },
    {
        finishActions: (_, { meta }) => (meta?.loadCart ? [loadWorkingOrder(meta.loadCart)] : []),
        errorActions: () => [
            snackbarAdd({
                message: format("An error occurred. Please refresh your browser and try again in a few minutes."),
            }),
        ],
    },
);
